import { action } from 'typesafe-actions'
import { UserActionTypes } from './types'
import { IUser } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(UserActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IUser[]) => action(UserActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(UserActionTypes.LIST_ERROR, errors)
export const listClear = () => action(UserActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(UserActionTypes.SELECT, id)
export const selectedData = () => action(UserActionTypes.SELECTED)
export const selectedClear = () => action(UserActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IUser) => action(UserActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IUser) => action(UserActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(UserActionTypes.CREATE_ERROR, errors)

// Read
export const readRequest = (data: IUser) => action(UserActionTypes.READ_REQUEST, data)
export const readSuccess = (data: IUser) => action(UserActionTypes.READ_SUCCESS, data)
export const readError = (errors: any) => action(UserActionTypes.READ_ERROR, errors)

// Update
export const updateRequest = (keyValues: any) => action(UserActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IUser) => action(UserActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(UserActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IUser) => action(UserActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(UserActionTypes.DELETE_SUCCESS, id)  // Return deleted User id to remove from state
export const deleteError = (errors: any) => action(UserActionTypes.DELETE_ERROR, errors)

// Reset User Password
export const resetPasswordRequest = (keyValues: any) => action(UserActionTypes.RESETPASSWORD_REQUEST, keyValues)
export const resetPasswordSuccess = (keyValues: any) => action(UserActionTypes.RESETPASSWORD_SUCCESS, keyValues) // Newly created data
export const resetPasswordError = (errors: any) => action(UserActionTypes.RESETPASSWORD_ERROR, errors)

// Search Request
export const downloadRequest = (searchParams:any) => action(UserActionTypes.DOWNLOAD_REQUEST, searchParams)
export const downloadSuccess = (url: string) => action(UserActionTypes.DOWNLOAD_SUCCESS, url)
export const downloadError = (errors: any) => action(UserActionTypes.DOWNLOAD_ERROR, errors)